// extracted by mini-css-extract-plugin
export default {"VideoBackground":"style_VideoBackground__NiJVL","background":"style_background__Ouv1y"};